import { motion } from "framer-motion";

export function Reveal({ children, delay = 0, y = 28, className = "" }) {
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.85, delay, ease: [0.16, 1, 0.3, 1] }}
      className={className}
    >
      {children}
    </motion.div>
  );
}

export function SectionHeading({ eyebrow, title, copy, align = "left", level = 2 }) {
  const HeadingTag = level === 1 ? "h1" : "h2";
  return (
    <Reveal className={align === "center" ? "text-center" : ""}>
      <p className="eyebrow" data-testid="section-eyebrow">{eyebrow}</p>
      <HeadingTag className="mt-4 font-serif text-2xl font-normal tracking-tight text-slate-100 sm:text-3xl lg:text-4xl">
        {title}
      </HeadingTag>
      {copy && (
        <p className={`mt-5 max-w-2xl text-base font-light leading-relaxed text-slate-400 ${align === "center" ? "mx-auto" : ""}`}>
          {copy}
        </p>
      )}
    </Reveal>
  );
}
